import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { NotFound } from 'components/atoms/result';
import { Page } from 'components/molecules/page';
import { RoutePaths } from 'constant';
import {
  ApiErrorData,
  ApiErrorType,
  ArchivedProjectApiErrorData,
} from 'queries/error';
import { ArchivedProjectErrorPage } from './archive-error';

const StyledPage = styled(Page)`
  align-items: center;
  justify-content: center;
`;

interface Props {
  error: ApiErrorData;
}

export const ProjectDetailError: FC<Props> = ({ error }) => {
  const renderError = () => {
    switch (error?.response?.data.type) {
      case ApiErrorType.RecordArchived:
        return (
          <ArchivedProjectErrorPage
            error={error as ArchivedProjectApiErrorData}
          />
        );
      case ApiErrorType.RecordDeleted:
        return (
          <StyledPage>
            <NotFound
              title={<FormattedMessage id="project.deleted.error.404.title" />}
              subTitle={
                <FormattedMessage id="project.deleted.error.404.info" />
              }
              linkTo={RoutePaths.projects}
              actionText={<FormattedMessage id="project.404.action" />}
            />
          </StyledPage>
        );
      default:
        return (
          <StyledPage>
            <NotFound
              title={
                <FormattedMessage id="project.not_found.error.404.title" />
              }
              subTitle={
                <FormattedMessage id="project.not_found.error.404.info" />
              }
              linkTo={RoutePaths.projects}
              actionText={<FormattedMessage id="project.404.action" />}
            />
          </StyledPage>
        );
    }
  };

  return renderError();
};
